export const isString = (value) => typeof value === "string" && value.trim() !== "";
export const isBoolean = (value) => typeof value === "boolean";
export const isArray = (value) => Array.isArray(value);

// Función para comprobar si un string representa una fecha válida
export const isValidDateString = (value: any) => {
  if (typeof value !== "string" || value.trim() === "") return false;

  const date = new Date(value);
  return date instanceof Date && !Number.isNaN(date.getTime());
};
